import NotFooterLayout from 'layouts/NotFooterLayout'
import ManageMerchant from 'components/ManageMerchant'

function ManageMerchantPage() {
  return (
    <>
      <NotFooterLayout namePage="ตั้งค่าที่อยู่รับสินค้า">
        <div className="layout-content">
          <ManageMerchant />
        </div>
      </NotFooterLayout>
    </>
  )
}

export default ManageMerchantPage
